<template>
  <div class="inquiry_list">
    <el-form :inline="true" :model="dataForm">
      <el-form-item label="">
        <el-input
          v-model.trim="dataForm.projName"
          placeholder="项目名称（模糊）"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model.trim="dataForm.contractNo"
          placeholder="中控合同编号(模糊)"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model.trim="dataForm.custContractNo"
          placeholder="用户合同编号（模糊）"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model.trim="dataForm.finalCustName"
          placeholder="最终客户名称（模糊）"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model.trim="dataForm.projManager"
          placeholder="项目经理姓名（模糊）"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model.trim="dataForm.salManager"
          placeholder="销售经理姓名（模糊）"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="butt" type="primary" @click="getDataList(1)"
          >查询</el-button
        >
        <el-button class="butt" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      key="inquiryTable"
      v-loading="dataLoading"
      border
    >
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无数据" />
        <div>暂无数据</div>
      </div>
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="contractNo"
        header-align="center"
        align="center"
        width="150px"
        label="中控合同编号"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <a href="javascript:" @click="detailHandle(scope.row)">
            {{scope.row.contractNo}}
          </a>
        </template>
      </el-table-column>
      <el-table-column
        prop="custContractNo"
        header-align="center"
        align="center"
        width="150px"
        label="用户合同编号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="custName"
        header-align="center"
        align="center"
        width="150px"
        label="客户名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="finalCustName"
        header-align="center"
        align="center"
        width="150px"
        label="最终客户"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="projName"
        header-align="center"
        align="center"
        width="150px"
        show-overflow-tooltip
        label="项目名称"
      ></el-table-column>
      <el-table-column
        prop="salManager"
        header-align="center"
        align="center"
        label="销售经理"
        width="150px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="salManagerPhone"
        header-align="center"
        align="center"
        width="150px"
        show-overflow-tooltip
        label="销售经理电话"
      ></el-table-column>
      <el-table-column
        prop="projManager"
        header-align="center"
        align="center"
        width="150px"
        label="项目经理"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="projManagerPhone"
        header-align="center"
        align="center"
        width="150px"
        label="项目经理电话"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="操作"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="detailHandle(scope.row)">
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="dataForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="dataForm.limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'afterSalesList', // 询价列表页
  data () {
    return {
      dataLoading: false,
      dataForm: {
        page: 1,
        limit: 10,
        projName: '',
        contractNo: '',
        custContractNo: '',
        finalCustName: '',
        projManager: '',
        salManager: ''
      },
      total: 0,
      dataList: []
    }
  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    reset () {
      this.dataForm = {
        ...this.dataForm,
        projName: '',
        contractNo: '',
        custContractNo: '',
        finalCustName: '',
        projManager: '',
        salManager: ''
      }
      this.getDataList(1)
    },
    getDataList () {
      this.getInquriyDataList(1)
    },
    // 获取列表数据
    getInquriyDataList (page = this.dataForm.page) {
      if(
        !this.$store.state.user.company ||
        !this.$store.state.user.company.companyCode ||
        !this.$store.state.user.company.companyId
      ){
        return
      }
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      let obj = {
        custCode: this.$store.state.user.company.companyCode,
        custId: this.$store.state.user.company.companyId,
        ...this.dataForm
      }
      this.$http
        .post(`/front/bpm/supcon-project/list`, obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.count || 0
          this.dataList = res.data.dataList || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getInquriyDataList(1)
    },
    handleCurrentChange (val) {
      this.dataForm.page = val
      this.getInquriyDataList()
    },
    // 查看详情
    detailHandle (row) {
      sessionStorage.setItem('project-detail', JSON.stringify(row))
      this.$router.push({
        path: '/personalCenter/project-detail',
        query: {
          contractNo: row.contractNo
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.inquiry_list {
  .title_row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .inquiry-tab-item {
    display: inline-block;
    margin-left: 10px;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active {
    color: #1d65a8;
    border-bottom: 2px solid #1d65a8;
  }
  .tooltip-content {
    max-width: 500px;
    text-align: center;
    border-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .back_content {
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
